import { type NodeRenderer } from '@contentful/rich-text-react-renderer'
import React from 'react'

export const document: NodeRenderer = (node, children) => (
  <div className="group-[.is-blue]/section-template:text-text-inverse">
    {children}
  </div>
)
